import React, { useState, useEffect } from 'react';
import { TextField, Autocomplete, CircularProgress } from '@mui/material';

const CowTagbyId = ({ onSelect }) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [value, setValue] = useState(null);


  useEffect(() => {
    // Fetch data from your backend API
    fetch('https://sasyavatagro.com/repos/api/dairyfarm/Tagbyid')
      .then((res) => res.json())
      .then((data) => {
//        console.log(data);
        setOptions(data); // Expecting [{id: 1, name: 'Option 1'}, ...]
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching data:", err);
        setError("Failed to load options");
        setLoading(false);
      });
  }, []);

  useEffect(()=>{
    if(value) setValue(null);
  },[value]);

  return (
    <Autocomplete
      options={options}
      value={value}
      getOptionLabel={(option) => option.Tag || ""}
      loading={loading}
      onChange={(event, newValue) => {
        onSelect(newValue); // Pass selected object back to parent
  //      setValue(null);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Select ..."
          variant="outlined"
          error={!!error}
          helperText={error}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
        />
    );
}

export default CowTagbyId;